// One message at a time; leave every block editable in Shopify.
if (!customElements.get('rof-announcement-rotator')) {
  customElements.define('rof-announcement-rotator', class extends HTMLElement {
    connectedCallback() {
      this.messages = [...this.querySelectorAll('.announcement-bar__message')];
      this.index = 0;
      this.hovered = false;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.addEventListener('mouseenter', () => { this.hovered = true; this.schedule(); }, options);
      this.addEventListener('mouseleave', () => { this.hovered = false; this.schedule(); }, options);
      this.addEventListener('focusin', () => this.schedule(), options);
      this.addEventListener('focusout', () => queueMicrotask(() => this.isConnected && this.schedule()), options);
      document.addEventListener('visibilitychange', () => this.schedule(), options);
      this.motion.addEventListener('change', () => this.schedule(), options);
      this.addEventListener('shopify:block:select', event => {
        const index = this.messages.indexOf(event.target.closest('.announcement-bar__message'));
        if (index >= 0) this.select(index);
      }, options);
      this.select(0);
    }

    select(index) {
      if (!this.messages.length) return;
      this.index = (index + this.messages.length) % this.messages.length;
      this.messages.forEach((message, i) => {
        const selected = i === this.index;
        message.classList.toggle('is-selected', selected);
        message.setAttribute('aria-hidden', String(!selected));
        message.inert = !selected;
      });
      this.schedule();
    }

    schedule() {
      clearTimeout(this.timer);
      const autoplay = this.dataset.autoplay === 'true' && this.messages.length > 1 && !this.motion.matches && !window.Shopify?.designMode;
      const stopped = !autoplay || this.hovered || document.hidden || this.matches(':focus-within');
      this.querySelector('.announcement-bar__message-list').setAttribute('aria-live', stopped ? 'polite' : 'off');
      if (stopped) return;
      this.timer = setTimeout(() => this.select(this.index + 1), Math.max(3, Number(this.dataset.interval) || 5) * 1000);
    }

    disconnectedCallback() {
      clearTimeout(this.timer);
      this.abort?.abort();
    }
  });
}
